"use client";
import React, { createContext, useContext, Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { ParcoursId } from '@/lib/constants';

type UserTypeContextType = {
  userType: ParcoursId;
};

const UserTypeContext = createContext<UserTypeContextType | undefined>(undefined);

const UserTypeContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const searchParams = useSearchParams();
  const userType = (searchParams.get("type") as ParcoursId) || "citizen";

  return (
    <UserTypeContext.Provider value={{ userType }}>
      {children}
    </UserTypeContext.Provider>
  );
};

export const UserTypeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <UserTypeContent>{children}</UserTypeContent>
    </Suspense>
  );
};

export const useUserTypeContext = (): UserTypeContextType => {
  const context = useContext(UserTypeContext);
  if (context === undefined) {
    throw new Error('useUserTypeContext must be used within a UserTypeProvider');
  }
  return context;
}; 